export const queryParam = (param: string) => new URLSearchParams(window.location.search).get(param);
